import { render, staticRenderFns } from "./BannerDetails.vue?vue&type=template&id=3b920069&scoped=true"
import script from "./BannerDetails.vue?vue&type=script&lang=js"
export * from "./BannerDetails.vue?vue&type=script&lang=js"
import style0 from "./BannerDetails.vue?vue&type=style&index=0&id=3b920069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b920069",
  null
  
)

export default component.exports